// import logo from './logo.svg';
import './App.css';
import Home from './Home';
import { Routes, Route } from 'react-router-dom'
import Services from './Services';
import Contact from './Contact';



//style

import  './css/bootstrap.min.css';
import  './css/bootstrap-theme.min.css';
import  './css/block_grid_bootstrap.css';
import  './css/font-awesome.min.css';
import  './css/typicons.min.css';
import  './css/odometer-theme-default.css';
import  './css/slider-pro.min.css';
import  './css/animate-custom.css';
import  './css/owl.carousel.css';
import  './css/owl.theme.default.min.css';
import  './css/slicknav.min.css';
import  './css/style.css';

// import { Helmet } from "react-helmet"



function App() {
  return (

    <>




      <div className="header header2">
        <div className="topbar">
          <div className="row">
            <div className="col-sm-8">
              <ul className="phone">
                <li><span className="typcn typcn-location-outline"></span>Gandhi Square Road, Jolly Medicals Building, Kattappana - 685508</li>
                <li><span className="typcn typcn-phone-outline"></span>04868 272484</li>
              </ul>
            </div>
            <div className="col-sm-4">
              <ul className="toplinks">
                <li>vtthomas414@gmail.com</li>
                <li>9446339908 </li>
                {/* <li><a href="#search"><i className="fa fa-search"></i></a></li> */}
                {/* <li><a href="shop-cart.html"><i className="fa fa-shopping-bag" aria-hidden="true"></i><span */}
                  {/* className="badge">2</span></a></li> */}

              </ul>
            </div>
          </div>
        </div>

        {/* <div id="search">
          <button type="button" className="close">×</button>
          <form>
            <span>Type and Press enter</span>
            <input type="search" defaultValue="" placeholder="" />
          </form>
        </div> */}

        <div className="header-navigation">
          <div className="row">
            <div className="col-sm-12">
              <div className="logonav">
                <div className="row no-gutter">
                  <div className="col-sm-5">
                    <div className="logo">
                      <a href="index-2.html">
                        <img src="images/logo.png" alt="" />
                      </a>
                    </div>
                  </div>
                  <div className="col-sm-7">
                    <nav id="desktop-menu">
                      <ul className="sf-menu" id="navigation">
                        {/* <li className="current"><a href="#">Home</a>

                        </li> */}
                      

                        <li><a href="/">Home</a></li>
                        <li><a href="/services">Services</a></li>
                        <li><a href="/contact">Contact</a></li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        
      </Routes>


      <section className="footer">

        <div className="footer-elements">
          <div className="row">
            <div className="col-sm-12">
              <div className="row no-gutter">

                <div className="col-sm-3">
                  <div className="footer-element">
                    <span className="typcn typcn-watch"></span>
                    <p>MONDAY TO FRIDAY<span>09:00 - 20:00</span></p>
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="footer-element">
                    <span className="typcn typcn-location-outline"></span>
                    <p>GANDHI SQUARE ROAD<span>KATTAPPANA - 685508</span></p>
                  </div>
                </div>

                <div className="col-sm-3">
                  <div className="footer-element">
                    <span className="typcn typcn-mail"></span>
                    <p>E-MAIL:<span><a href="#">VTTHOMAS414@GMAIL.COM</a></span></p>
                  </div>
                </div>

                <div className="col-sm-3">
                  <div className="footer-element">
                    <span className="typcn typcn-phone-outline"></span>
                    <p>CALL US:<span>04868 272484</span></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-widgets">
          <div className="row">

            <div className="col-sm-4">
              <div className="footer-widget">
                <div className="small-logo">
                  <img src="images/logo.png" alt="" />
                </div>
                <p>V T THOMAS & ASSOCIATES IS A LEADING TAX CONSULTANCY AND MANAGEMENT CONSULTANCY FIRM BASED OUT IN KATTAPPANA IDUKKI KERALA. V T THOMAS AND ASSOCIATES HAVE its ORIGIN since 1982</p>
                <ul className="social-links">
                  {/* <li><a href="#" title="Twitter"><i className="fa fa-twitter"></i></a></li> */}
                  <li><a href="https://www.facebook.com/vtthomasAndAssociates" title="Facebook"><i className="fa fa-facebook"></i></a></li>
                  <li><a href="https://www.linkedin.com/in/jacob-tom-3b0214272/" title="Linkedin"><i className="fa fa-linkedin"></i></a></li>
                  {/* <li><a href="#" title="Pinterest"><i className="fa fa-pinterest-p"></i></a></li> */}
                </ul>
              </div>
            </div>

            <div className="col-sm-6">
              <div className="footer-widget">
                <h5>LOCATION</h5>
                <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3932.138307169074!2d77.11287667459229!3d9.754350277214327!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b07a9fd7c985fc7%3A0x4722561f86db3400!2sV.T%20THOMAS%20AND%20ASSOCIATES!5e0!3m2!1sen!2sin!4v1702239413488!5m2!1sen!2sin"
                        width="100%"
                        height="100%"
                        allowfullscreen=""
                        loading="lazy"
                        referrerpolicy="no-referrer-when-downgrade"
                      ></iframe>
              </div>
            </div>

            <div className="col-sm-2">
              <div className="footer-widget">
                <h5>LINKS</h5>
                <ul className="posts">
                        

                        <li><a href="/">Home</a></li>
                        <li><a href="/services">Services</a></li>
                        <li><a href="/contact">Contact</a></li>
                  {/* <li><a href="#">HOME</a></li>
                  <li><a href="#">SERVICES</a></li>
                  <li><a href="#">PROJECTS</a></li>
                  <li><a href="#">BLOG</a></li>
                  <li><a href="#">CONTACT</a></li> */}
                </ul>
              </div>
            </div>



          </div>
        </div>
      </section>

      <div className="copyright">
        <div className="row">
          <div className="col-sm-12">
            <p className="text-center">Copyright Kasperob Robotics  All Rights Reserved.</p>
          </div>
        </div>
      </div>

      <a href="#top" id="back-to-top"><i className="fa fa-angle-up"></i></a>


    

    </>
  );
}

export default App;

